/**
 * Warehouses list route — thin shim mounting `<WarehousesListPage />`.
 *
 * @see apps/web/src/features/inventory/warehouses/warehouses-list-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { WarehousesListPage } from "../../../../features/inventory/warehouses/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/warehouses/")({
  component: WarehousesListRoute,
});

function WarehousesListRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Inventory", to: "/" }, { label: "Warehouses" }]}
      viewportClassName="p-0"
      contentClassName="max-w-none"
    >
      <WarehousesListPage />
    </WorkspaceShell>
  );
}
